import React from 'react';
import './PrivacyPolicy.css'; // Import the CSS file

const PrivacyPolicy = () => {
  return (
    <section className="privacy-policy-section">
      <title>Datenschutzerklärung – Nexite IT</title>
      <meta
        name="description"
        content="Datenschutzerklärung der Nexite IT: Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO."
      />
      <link rel="canonical" href="https://www.nexite-it.com/datenschutz" />

      <div className="privacy-policy-container">
        <h1>Datenschutzerklärung</h1>

        <div className="privacy-policy-content">
          <h2>1. Information über die Erhebung personenbezogener Daten</h2>
          <p>
            Im Folgenden informieren wir über die Verarbeitung personenbezogener Daten bei Nutzung unserer Website. Personenbezogene Daten sind alle Daten, die auf Sie persönlich beziehbar sind, z. B. Name, Adresse, E-Mail-Adressen, Nutzerverhalten. Dadurch möchten wir Sie über unsere Verarbeitungsvorgänge informieren und zugleich den gesetzlichen Pflichten, insbesondere aus der EU-Datenschutz-Grundverordnung (DS-GVO) nachkommen.
          </p>

          <h3>Verantwortlicher gem. Art. 4 Abs. 7 DS-GVO</h3>
          <p>
            Nexite IT <br />
            Inhaber: Khashayar Alavi<br />
            Auf dem Schnorrenberg 6<br />
            50354 Hürth<br />
            <strong>Telefon:</strong> +49 (0) 178 / 86 22 28 2<br />
            <strong>E-Mail:</strong> info[at]nexite-it.com
          </p>
          <p>
            Unseren Datenschutzbeauftragten erreichen Sie unter <a href="mailto:info@nexite-it.com">info@nexite-it.com</a> oder unserer Postadresse mit dem Zusatz „der Datenschutzbeauftragte“.
          </p>

          <h2>2. Verarbeitung personenbezogener Daten bei Besuch unserer Website</h2>
          <p>
            Bei der informatorischen Nutzung der Website, also der bloßen Betrachtung ohne eine Registrierung und ohne dass Sie uns anderweitig Informationen mitteilen, verarbeiten wir die personenbezogenen Daten, die Ihr Browser an unseren Server übermittelt. Die nachfolgend beschriebenen Daten sind für uns technisch erforderlich, um Ihnen unsere Website anzuzeigen und die Stabilität und Sicherheit zu gewährleisten und müssen daher von uns verarbeitet werden. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DS-GVO:
          </p>
          <ul>
            <li>IP-Adresse</li>
            <li>Datum und Uhrzeit der Anfrage</li>
            <li>Zeitzonendifferenz zur Greenwich Mean Time (GMT)</li>
            <li>Inhalt der Anforderung (besuchte Seite)</li>
            <li>Zugriffsstatus/HTTP-Statuscode</li>
            <li>jeweils übertragene Datenmenge</li>
            <li>vorher besuchte Seite</li>
            <li>Browser</li>
            <li>Betriebssystem</li>
            <li>Sprache und Version der Browsersoftware</li>
          </ul>

          <h2>3. Datenverarbeitung zur Vertragsabwicklung</h2>
          <p>
            Sofern Sie bei uns Kunde sind oder werden, verarbeiten wir Ihre Kontakt-, Vertrags-, Zahlungs- und Kommunikationsdaten zur Erbringung und Abrechnung der vertragsgegenständlichen Leistungen, die Sie unseren AGB entnehmen können. Ihre Daten werden zu vorgenanntem Zweck ggf. an uns unterstützende Dienstleister (Service-Provider, Betreiber von Kommunikationsanwendungen, etc.) weitergegeben, die wir selbstverständlich sorgfältig ausgewählt haben und die an unsere Weisungen gebunden sind. Rechtsgrundlage ist das bestehende Vertragsverhältnis (Art. 6 Abs. 1 S. 1 lit. b DSGVO).
          </p>

          <h2>4. Datenverarbeitung bei der Kontaktaufnahme</h2>
          <p>
            Bei Ihrer Kontaktaufnahme mit uns per E-Mail, Telefon oder über ein Kontaktformular werden die von Ihnen mitgeteilten Daten (z.B. E-Mail-Adresse, Name, Telefonnummer oder auch Inhalt der Anfrage) von uns verarbeitet, um Ihre Fragen zu beantworten und/oder Ihr Anliegen zu bearbeiten. Die Rechtsgrundlage ist Art. 6 Abs. 1 lit. a) und b) DSGVO und zwar Ihre Einwilligung oder eine vorvertragliche Maßnahme.
          </p>

          <h2>5. Weitere Funktionen und Angebote unserer Website</h2>
          <p>
            Neben der rein informatorischen Nutzung unserer Website bieten wir verschiedene Leistungen an, die Sie bei Interesse nutzen können und verwenden weitere übliche Funktionen zu Analyse oder Vermarktung unserer Angebote, die nachfolgend näher vorgestellt werden. Dazu müssen Sie in der Regel weitere personenbezogene Daten angeben bzw. wir verarbeiten solche weiteren Daten, die wir zur Durchführung der jeweiligen Leistungen nutzen. Für alle hier beschriebenen Datenverarbeitungszwecke gelten die zuvor genannten Grundsätze zur Datenverarbeitung.
          </p>

          <h2>6. Widerspruch oder Widerruf gegen die Verarbeitung Ihrer Daten</h2>
          <p>
            Falls Sie eine Einwilligung zur Verarbeitung Ihrer Daten erteilt haben, können Sie diese jederzeit widerrufen. Ein solcher Widerruf beeinflusst die Zulässigkeit der Verarbeitung Ihrer personenbezogenen Daten, nachdem Sie ihn gegenüber uns ausgesprochen haben. Die Zulässigkeit der Verarbeitung Ihrer Daten bis zum Zeitpunkt Ihres Widerrufs bleibt unberührt.
          </p>

          <h2>7. Verarbeitung von Daten aus Ihren Endgeräten („Cookie-Richtlinie“)</h2>
          <p>
            Zusätzlich zu den oben genannten Daten verwenden wir bei Ihrer Nutzung unserer Website technische Hilfsmittel für verschiedene Funktionen, insbesondere Cookies, die auf Ihrem Endgerät gespeichert werden können. Sie haben bei Aufruf unserer Website und jederzeit später die Wahl, ob Sie das Setzen von Cookies generell zulassen oder welche einzelnen zusätzlichen Funktionen Sie auswählen möchten. Änderungen können Sie in Ihren Browsereinstellungen oder über unseren Consent-Manager vornehmen.
          </p>

          <h2>8. Web Analytics</h2>
          <p>
            Diese Website nutzt Google Analytics, einen Webtracking-Dienst der Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland („Google“). Zweck unserer Nutzung des Tools ist es, die Analyse Ihrer Nutzerinteraktionen auf Websites und in Apps zu ermöglichen und durch die gewonnenen Statistiken und Berichte unser Angebot zu verbessern und für Sie als Nutzer interessanter zu gestalten.
          </p>

          <h2>9. Online-Werbung</h2>
          <p>
            Wir nutzen das Angebot Google Ads, um mit Hilfe von Werbeanzeigen auf unsere Angebote aufmerksam zu machen. Sofern Sie über eine Google-Anzeige auf unsere Website gelangen, wird von Google Ads ein Cookie in ihrem Endgerät gespeichert. Rechtsgrundlage für die Verarbeitung Ihrer Daten ist Art. 6 Abs. 1 S. 1 lit. a DS-GVO, dh die Einbindung erfolgt nur nach Ihrer Einwilligung.
          </p>

          <h2>10. Ihre Rechte</h2>
          <p>
            Sie haben gegenüber einem Verantwortlichen folgende Rechte hinsichtlich der Sie betreffenden personenbezogenen Daten:
          </p>
          <ul>
            <li>Recht auf Auskunft,</li>
            <li>Recht auf Berichtigung oder Löschung,</li>
            <li>Recht auf Einschränkung der Verarbeitung,</li>
            <li>Recht auf Widerspruch gegen die Verarbeitung,</li>
            <li>Recht auf Datenübertragbarkeit.</li>
          </ul>
          <p>
            Sie haben zudem das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten durch uns zu beschweren.
          </p>

          <h2>11. Schlussbestimmungen</h2>
          <p>
            Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um Ihre Daten zu schützen, insbesondere gegen zufällige oder vorsätzliche Manipulation, Verlust, Zerstörung oder gegen den Angriff unberechtigter Personen. Unsere Sicherheitsmaßnahmen werden entsprechend der technologischen Entwicklung fortlaufend verbessert.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;